import installationInstructions from './installationInstructions';

const pecCamContent = {
  installationInstructions
}

export { pecCamContent };
